import PublicThemes from '@/pages/publicPages/PublicThemes/PublicThemes';
import PublicThemesSSP from '@/pages/publicPages/PublicThemes/PublicThemes.ssp';
import PageMetadata from '@/v2/domains/SEO/components/PageMetadata/PageMetadata';

export default function Themes(props) {
  return (
    <>
      <PageMetadata
        title="Spanish Learning Themes for Kids | Rockalingua"
        description="All the Rockalingua content organized by subject - theme"
      />
      <PublicThemes {...props.pageProps} />
    </>
  );
}

export const getServerSideProps = async (context) =>
  await PublicThemesSSP({ context });
